import { supabase } from "@/integrations/supabase/client";

/** Profile photos are stored privately; links are re-signed for a short time when shown. */
const SIGN_SECONDS = 60 * 60;
const cache = new Map<string, { url: string; expires: number }>();
const inflight = new Map<string, Promise<string | undefined>>();

export function profilePhotoPath(value?: string | null): string | null {
  if (!value) return null;
  if (value.startsWith("profile-photos:")) return value.slice("profile-photos:".length);
  const m = value.match(/\/storage\/v1\/object\/(?:sign|public|authenticated)\/profile-photos\/([^?]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

export async function resolveProfilePhotoUrl(value?: string | null): Promise<string | undefined> {
  const path = profilePhotoPath(value);
  if (!path) return value ?? undefined;
  const hit = cache.get(path);
  if (hit && hit.expires > Date.now()) return hit.url;
  if (inflight.has(path)) return inflight.get(path);
  const p = supabase.storage
    .from("profile-photos")
    .createSignedUrl(path, SIGN_SECONDS)
    .then(({ data }) => {
      inflight.delete(path);
      if (!data?.signedUrl) return undefined;
      cache.set(path, { url: data.signedUrl, expires: Date.now() + (SIGN_SECONDS - 300) * 1000 });
      return data.signedUrl;
    });
  inflight.set(path, p);
  return p;
}
